import { Route } from '@angular/router';

import { UserRouteAccessService } from '../shared';
import { DashboardComponent } from './';

export const DASHBOARD_ROUTE: Route = {
    path: 'dashboard',
    data: {
        authorities: ['ROLE_SCHOOL_ADMIN'],
        pageTitle: 'jYoguiApp.dashboard.title'
    },
    component: DashboardComponent,
    canActivate: [ UserRouteAccessService ]
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/dashboard/dashboard.route.ts